import classNames from "classnames";
import { Menu, MenuButton, MenuItem, MenuPopover } from "@reach/menu-button";
import { positionRight } from "@reach/popover";
import { NavMenuPopoverArgsType } from "./type";
import Animations from "../animations";
import Variant from "shared/enums/Variant";

function NavMenuPopover({ buttonVariant = Variant.PRIMARY, ...props }: NavMenuPopoverArgsType) {
  return (
    <div className={classNames("navMenuPopover", props.additionalClass)}>
      <Menu>
        <MenuButton
          className={classNames(
            "ptButton smooth",
            `ptButton--${buttonVariant}`,
            props.isOutlinedBtn ? `ptButton--${buttonVariant}Outlined` : "",
            {
              buttonWithIcon: props.buttonIcon
            }
          )}>
          {props.buttonIcon && props.buttonIcon} {props.label}
          {Boolean(props.idsToHighlight?.length) && <Animations.CircleScaleIn />}
        </MenuButton>
        <MenuPopover position={positionRight} className="slide-down navMenuPopover">
          <div className="navMenuPopover--container">
            <div className="navMenuPopover--items">
              {props.header && (
                <div className={classNames("navMenuPopover--menuTitle", props.headerClass)}>{props.header}</div>
              )}
              <div>
                {props.menuOptions.map(menuItem => (
                  <MenuItem
                    key={menuItem.key}
                    disabled={menuItem.disabled}
                    onSelect={menuItem.clickHandler}
                    className={menuItem.className}>
                    {menuItem.icon} {menuItem.label}
                    {props.idsToHighlight?.includes(menuItem.id || menuItem.key) && <Animations.CircleScaleIn />}
                  </MenuItem>
                ))}
              </div>
            </div>
          </div>
        </MenuPopover>
      </Menu>
    </div>
  );
}

export default NavMenuPopover;
